import { bl_svc_doc_line_RowClass } from '../../../dbschema/bl_svc_doc_line.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceDocLineContainerModel extends BaseContainerModel {
  bl_svc_doc_line: bl_svc_doc_line_RowClass = new bl_svc_doc_line_RowClass();
}
